import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SubGrupoEstoqueListComponent } from './subgrupo-estoque-list/subgrupo-estoque-list.component';
import { SubGrupoEstoqueFormComponent } from './subgrupo-estoque-form/subgrupo-estoque-form.component';
import { SubGrupoEstoqueViewComponent } from './subgrupo-estoque-view/subgrupo-estoque-view.component';
import { AuthGuard } from 'eddydata-lib';

const routes: Routes = [
  { path: '', component: SubGrupoEstoqueListComponent, canActivate: [AuthGuard] },
  { path: 'novo', component: SubGrupoEstoqueFormComponent, canActivate: [AuthGuard] },
  { path: ':id/editar', component: SubGrupoEstoqueFormComponent, canActivate: [AuthGuard] },
  { path: ':id/visualizar', component: SubGrupoEstoqueViewComponent, canActivate: [AuthGuard] },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SubGrupoEstoqueRoutingModule { }
